import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';




import { environment } from './environments/environment';
import { AppModule } from './app/appModule';


export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

console.debug('main: environment.production');

if (environment.production) {
  enableProdMode();
 
}

//if (environment.monitoringB) {
//  console.log('environment.monitoringB = true');

//  platformBrowserDynamic(providers).bootstrapModule(AppModuleBM)
//    .catch(err => console.log(err));
//}
//else {
 
platformBrowserDynamic(providers).bootstrapModule(AppModule)
    .catch(err => console.error(err));
//}
